import { useLocale, useTranslations } from 'next-intl';

import ArticleScrollObserver from '../atoms/ArticleScrollObserver';
import ArticleTags from '../atoms/ArticleTags';

import FBPixelScript from '@components/Analytics/Facebook/FBPixelScript';
import GAScript from '@components/Analytics/Google/GAScript';
import Comments from '@components/Article/Comments';
import { PremiumOnly } from '@components/Only';
import { getFBPixelEventProperties, getGAEventProperties } from '@utils/article/analytics';

export default function ArticleFooter({
  article,
  mainArticle,
  showComments,
  showTags,
  triggerAnalyticsEvents = true,
  triggerScrollObserver = true,
  viewType,
  analyticsData,
}) {
  const lang = useLocale();
  const t = useTranslations('main');
  const articlePath = `/${article.slug}`;
  const analyticsCustomParams = {
    ...analyticsData,
    ...getGAEventProperties(lang, article, viewType),
  };
  return (
    <>
      {showComments && (
        <PremiumOnly>
          <Comments slug={article.slug} postId={article.id} canWrite={true} />
        </PremiumOnly>
      )}
      {showTags && <ArticleTags tags={article.tags} title={t('posts.tags')} />}
      {triggerAnalyticsEvents && (
        <>
          <FBPixelScript
            event="ViewContent"
            id={article.id}
            values={getFBPixelEventProperties(lang, article, viewType)}
          />
          {mainArticle === true && (
            <GAScript event="transinfo_post_view" id={article.id} values={analyticsCustomParams} />
          )}
          {mainArticle === false && (
            <GAScript event="transinfo_post_scrolled_view" id={article.id} values={analyticsCustomParams} />
          )}
          {mainArticle === true && article.tags && (
            <>
              {article.tags.map((slug) => (
                <GAScript
                  event="transinfo_post_tag_view"
                  id={slug}
                  values={{
                    ...analyticsCustomParams,
                    transinfo_view_category: slug.slug,
                  }}
                />
              ))}
            </>
          )}
        </>
      )}
      {triggerScrollObserver && <ArticleScrollObserver articleTitle={article.title} articlePath={articlePath} />}
      <div className="xl:mt-2" />
    </>
  );
}
